import { slugify } from './functionalUtils';

const TEAM_MAP = {
  aik: 'aik',
  bkh: 'bk-hacken',
  deif: 'degerfors-if',
  dif: 'djurgardens-if',
  gbg: 'ifk-goteborg',
  ham: 'hammarby-if',
  hbk: 'halmstads-bk',
  ifbp: 'if-brommapojkarna',
  ife: 'if-elfsborg',
  iks: 'ik-sirius',
  kff: 'kalmar-ff',
  maif: 'mjallby-aif',
  mff: 'malmo-ff',
  nor: 'ifk-norrkoping',
  var: 'varbergs-bois',
  varn: 'ifk-varnamo',
  afc: 'afc-eskilstuna',
  gais: 'gais',
  gif: 'gefle-if',
  hif: 'helsingborg',
  ikb: 'ik-brage',
  jon: 'jonkopings-sodra',
  lan: 'landskrona-bois',
  ofk: 'ostersunds-fk',
  oif: 'osters-if',
  ois: 'orgryte-is',
  osk: 'orebro-sk',
  skaik: 'skovde-aik',
  sun: 'gif-sundsvall',
  tff: 'trelleborgs-ff',
  ubk: 'utsiktens-bk',
  vsk: 'vasteras-sk',
  sandif: 'sandif',
  iko: 'iko',
  fff: 'falkenbergs-ff',
  ume: 'umea-fc',
};

const TEAM_URLS = {
  futafc: 'https://afc-eskilstuna.se/team/mMZnBZnN',
  futbor: 'https://www.baikfutsal.se/',
  futck: 'https://www.fckalmar.se',
  futfcre: 'https://www.svenskalag.se/fc-real-internacional',
  futgbg: 'http://www.ifkgoteborgfutsal.se/',
  futham: 'http://www.hammarbyfotboll.se/',
  futkutd: 'https://www.laget.se/kalmarunitedfk',
  futnor: 'https://www.svenskalag.se/norrkopingfutsal-herrar',
  futorefc: 'http://www.orebrofutsal.se/',
  futoresk: 'http://www.oskfutsal.se/',
  futsko: 'https://www.skoftebynfutsal.se/',
  futudd2: 'http://uddevallafutsal.se/',
  futsod: 'https://www.laget.se/soderfutsal',
};

export const getTeamUrl = (id) => {
  const key = id?.toLowerCase();
  if (TEAM_MAP[key]) {
    return `/lagen/${TEAM_MAP[key]}`;
  }
  if (TEAM_URLS[key]) {
    return TEAM_URLS[key];
  }
  return false;
};

export const getPlayerUrlById = (id) => (id ? `/spelare/${id}` : '');

export const getMatchUrl = (season, matchId, homeTeamName, visitingTeamName) =>
  `/matcher/${season}/${matchId}/${slugify(homeTeamName)}-mot-${slugify(
    visitingTeamName
  )}`;
